// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  margin: 0 -15px;
  display: block;
  overflow-x: hidden;
}

.account-image {
  position: fixed;
  top: 0;
  right: 0;
  width: 41.66667%;
  overflow: hidden;
}
@media screen and (max-width: 959px) {
  .account-image {
    width: 90%;
    border-radius: 0;
    right: 0;
  }
}
.account-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/hero-image/hero-image.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/hero-image/hero-image.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;ACCF;;ADEA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;ACCF;ADCE;EAPF;IAQI,UAAA;IACA,gBAAA;IACA,QAAA;ECEF;AACF;ADAE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ACEJ","sourcesContent":[":host {\r\n  margin: 0 -15px;\r\n  display: block;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.account-image {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 41.66667%;\r\n  overflow: hidden;\r\n\r\n  @media screen and (max-width: 959px) {\r\n    width: 90%;\r\n    border-radius: 0;\r\n    right: 0;\r\n  }\r\n\r\n  img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n  }\r\n}",":host {\n  margin: 0 -15px;\n  display: block;\n  overflow-x: hidden;\n}\n\n.account-image {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 41.66667%;\n  overflow: hidden;\n}\n@media screen and (max-width: 959px) {\n  .account-image {\n    width: 90%;\n    border-radius: 0;\n    right: 0;\n  }\n}\n.account-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
